module.exports = __webpack_public_path__ + "img/heita.5de79ce.png";